import {
  CategoriesResponse,
  MetadataResponse,
  ProgressResponse,
  VideoLikesResponse,
} from "src/features/tangoAcademy/common/types";
import {
  enhancedFetch,
  getProxycadorHost,
} from "src/features/tangoAcademy/imports/common";

const DEFAULT_LIKES_PAGE_SIZE = 30;

export const getCategoriesApi = async (): Promise<CategoriesResponse> => {
  const response = await enhancedFetch(
    `${getProxycadorHost()}/academy/public/v1/categories?webclient=true`,
    {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    }
  );

  if (!response.ok) {
    throw new Error("Network response was not ok");
  }

  return response.json();
};

export const getVideoMetadataApi = async (
  videoId: string
): Promise<MetadataResponse> => {
  const response = await enhancedFetch(
    `${getProxycadorHost()}/academy/public/v1/video/${videoId}/metadata`
  );

  if (!response.ok) {
    throw new Error("Network response was not ok");
  }

  return response.json();
};

export const getVideoLikesApi = async (
  videoId: string,
  page: number,
  pageSize: number = DEFAULT_LIKES_PAGE_SIZE
): Promise<VideoLikesResponse> => {
  const response = await enhancedFetch(
    `${getProxycadorHost()}/academy/public/v1/video/${videoId}/reactions?page=${page}&pageSize=${pageSize}`,
    {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    }
  );

  if (!response.ok) {
    throw new Error("Network response was not ok");
  }

  return response.json();
};

export const postLikeApi = async (id: string, isLiked: boolean) => {
  const response = await enhancedFetch(
    `${getProxycadorHost()}/academy/public/v1/video/${id}/reaction?isLiked=${isLiked}`,
    {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    }
  );

  if (!response.ok) {
    throw new Error("Failed to post video reaction");
  }
};

export const postVideoProgressApi = async (
  id: string,
  percentage: number
): Promise<ProgressResponse> => {
  const response = await enhancedFetch(
    `${getProxycadorHost()}/academy/public/v1/video/${id}/progress?percentage=${percentage}`,
    {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    }
  );

  if (!response.ok) {
    throw new Error("Failed to post video progress");
  }

  return response.json();
};
